import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Typography, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../store/rootStore';
import ChannelNotification from '../../components/ChannelNotification';
import styles from './Details.module.scss';
import { formatDateTime } from '../../../../helpers';
import { getNotificationTitle, isNotificationOfType } from '../../helpers';
const { Text } = Typography;
const NotificationDetails = ({ id, onResolved }) => {
    const { notificationsStore, timeFormat } = useStore();
    const { t, i18n } = useTranslation();
    const notification = notificationsStore.getNotification(id);
    const title = notification
        ? getNotificationTitle(notification, t(`notificationStatus.${notification.status}`))
        : '';
    useEffect(() => {
        notificationsStore.markAsRead(id);
    }, [id, notificationsStore]);
    return (React.createElement("div", { className: styles.details }, notification ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.header },
            React.createElement("h2", { className: styles.title, dir: "auto" }, title),
            React.createElement(Text, { type: "secondary" }, formatDateTime(notification.date, i18n.language, timeFormat))),
        notification.description !== title && React.createElement(Text, { dir: "auto" }, notification.description),
        isNotificationOfType(notification, 'channel') && (React.createElement(ChannelNotification, { notification: notification, onResolved: onResolved })))) : (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: t('notificationNotFound') }))));
};
export default observer(NotificationDetails);
